import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppSettings } from './enums/app-settings.enum';
import { ApplicationInitializationService } from './services/application-initialization.service';
import { AdobeAnalyticsService } from './services/adobe-analytics.service';
import { LanguageSwitchService } from './services/language-switch.service';
import { ProductService } from './services/product.service';
import { SessionDataService } from './services/session-data.service';
import { UtilitiesService } from './utilities/utilities.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
declare let ga: any;
declare var $: any;
declare var window: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  title = 'plans';
  loaderColor: string = AppSettings.LOADER_COLOR;
  URLS: any;
  currentUrl: string = null;
  loadAPI: Promise<any>;

  constructor(
    private router: Router,
    private UTS: UtilitiesService,
    private sessionManagementService: SessionDataService,
    private route: ActivatedRoute,
    private LSS: LanguageSwitchService,
    private R: Renderer2,
    private applicationInitializationService: ApplicationInitializationService,
    private AAS: AdobeAnalyticsService,
    private productService: ProductService,
    private changeDetectionRef: ChangeDetectorRef,
    private GAS: GoogleAnalyticsService
  ) {
    this.UTS.log(
      'BUILD 0.0.2 DEPLOYED 24-04-2024 Clearance Letter'
    );
    this.route.queryParamMap.subscribe((params) => {
      const token: any = { ...params };
      const parentLanguage = localStorage.getItem('curr_language');
      const parentLang = parentLanguage
        ? parentLanguage.toLocaleLowerCase()
        : 'english';
      const localLanguage = localStorage.getItem('language');
      const lang = token.params.locale
        ? token.params.locale.toLowerCase()
        : token.params.lang
          ? token.params.lang.toLowerCase()
          : localLanguage
            ? localLanguage.toLocaleLowerCase()
            : 'en';

      if (lang === 'ar' || parentLang === 'arabic') {
        this.LSS.setLanguage('ar');
        this.LSS.changeLanguage();
        this.UTS.setAHURL(`ar${AppSettings.APPLICATION_HEADER_URL}`);
        this.UTS.setAFURL(`ar${AppSettings.APPLICATION_FOOTER_URL}`);
        this.UTS.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
        this.URLS = {
          APPLICATION_HEADER_URL: 'ar' + AppSettings.APPLICATION_HEADER_URL,
          APPLICATION_FOOTER_URL: 'ar' + AppSettings.APPLICATION_FOOTER_URL,
          APPLICATION_NAVIATION_URL:
            'ar' + AppSettings.APPLICATION_NAVIATION_URL,
        };
      } else {
        this.LSS.setLanguage('en');
        this.LSS.changeLanguage();
        this.UTS.setAHURL(`en${AppSettings.APPLICATION_HEADER_URL}`);
        this.UTS.setAFURL(`en${AppSettings.APPLICATION_FOOTER_URL}`);
        this.UTS.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
        this.URLS = {
          APPLICATION_HEADER_URL: 'en' + AppSettings.APPLICATION_HEADER_URL,
          APPLICATION_FOOTER_URL: 'en' + AppSettings.APPLICATION_FOOTER_URL,
          APPLICATION_NAVIATION_URL:
            'en' + AppSettings.APPLICATION_NAVIATION_URL,
        };
      }
    });
  }
  ngOnInit() {
    this.loadScript(
      'https://maps.google.com/maps/api/js?key=' +
      this.applicationInitializationService?.environmentConfig?.MAP_KEY +
      '&libraries=placeses,visualization,drawing,geometry,places'
    ).then(() => { });
    this.loadScript(
      this.applicationInitializationService?.environmentConfig?.ADOBE_SCRIPT
    );
    this.sessionManagementService.getInitProperties().subscribe(
      (res) => {
        localStorage.properties = res;
        this.changeDetectionRef.detectChanges();
      },
      (error) => {
        
      }
    );
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.url;
      });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.route.queryParams.subscribe((q) => {
        if (q && q?.lang) {
          this.setPageOritentation(q.lang.toLocaleLowerCase());
        } else if (q && q?.locale) {
          this.setPageOritentation(q.locale.toLocaleLowerCase());
        } else {
          this.setPageOritentation(this.LSS.getLanguage());
        }
        const env = this.UTS.getENV();
        const ispreprod = document.location.href.includes("uat.etisalat.ae");
        if (env != 'mobile') {
          this.getHeaderCSSLibs(AppSettings.HEADER_LIBS);
          this.getHeaderLibs(AppSettings.HEADER_LIBS);
        }
      });
    }, 500);
  }
  ngOnDestroy() {
    this.destroy$.next();
  }

  public getHeaderURL() {
    return this.UTS.getAHURL();
  }

  public getFooterURL() {
    return this.UTS.getAFURL();
  }
  public getNavigationURL() {
    return this.UTS.getANURL();
  }

  setPageOritentation(lang) {
    if (lang == 'ar') {
      this.R.setAttribute(document.documentElement, 'lang', 'ar');
      this.R.setAttribute(document.body, 'dir', 'rtl');
    } else {
      this.R.setAttribute(document.documentElement, 'lang', 'en');
      this.R.setAttribute(document.body, 'dir', 'ltr');
    }
  }

  loadScript(src: string) {
    return new Promise((resolve, reject) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      document.getElementsByTagName('body')[0].appendChild(script);
      resolve('');
    });
  }

  getHeaderCSSLibs(headerUrl) {
    this.productService.getLibs('/' + headerUrl, 'GET').subscribe(
      (res: any) => {
        if (res?.htmlSrc) {
          const scriptRegex =
            /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
          const filteredHtml = res.htmlSrc.replace(scriptRegex, '');
          document
            .getElementsByTagName('head')[0]
            .insertAdjacentHTML('beforeend', filteredHtml);
        }
      },
      (e) => {
        console.log('failed to retrive header libs');
      }
    );
  }

  getHeaderLibs(headerUrl) {
    this.productService.getLibs('/' + headerUrl, 'GET').subscribe(
      (res: any) => {
        if (res?.htmlSrc) {
          this.loadScripts(
            res.htmlSrc,
            document.getElementById('headerLibs'),
            'header'
          );
        }
      },
      (e) => {
        console.log('failed to retrive header libs');
      }
    );
  }
  getFooterLibs(footerUrl) {
    this.productService.getCMSContent('/' + footerUrl, 'GET').subscribe(
      (res: any) => {
        if (res?.htmlSrc) {
          this.loadScripts(
            res.htmlSrc,
            document.getElementById('footerLibs'),
            'footer'
          );
        }
      },
      (e) => {
        console.log('failed to retrive footer libs');
      }
    );
  }
  loadScripts(htmlStr: string, targetEl: any, type: string) {
    let domParser = new DOMParser();
    const html = domParser.parseFromString(htmlStr, 'text/html');
    for (let index = 0; index < html?.scripts.length; index++) {
      const script = html.scripts[index];
      let scriptTag = this.R.createElement('script');
      scriptTag.type = 'text/javascript';
      scriptTag.src = script.src;
      scriptTag.async = true; // makes script run asynchronously
      this.R.appendChild(targetEl, scriptTag);
    }
  }
}
